import type { TrafficSignalNode } from './reguladores-placeholder';
import type { NewSignalOverride } from './overridesRuntime';

function buildManualSignal(a: NewSignalOverride): TrafficSignalNode {
  return {
    id: a.id,
    position: a.position,
    tags: { highway: 'traffic_signals', source: 'manual' },
  };
}

export function applySignalLifecycle(
  base: TrafficSignalNode[],
  added: NewSignalOverride[],
  removedIds: number[],
): TrafficSignalNode[] {
  const removed = new Set(removedIds);
  const kept = base.filter(s => !removed.has(s.id));
  const newOnes = added
    .filter(a => !removed.has(a.id))
    .map(buildManualSignal);
  return [...kept, ...newOnes];
}
